document.addEventListener("DOMContentLoaded", function () {
    // Select all UGC carousels (there can be none, one, or many)
    var swiperEls = document.querySelectorAll('.ugc-carousel__swiper');
    if (!swiperEls.length) return; // Exit if there are no UGC sliders on the page

    swiperEls.forEach(function (swiperEl) {
        // Initialize Swiper for each found carousel
        var swiper = new Swiper(swiperEl, {
            slidesPerView: 1.35,
            spaceBetween: 16,
            freeMode: false,
            speed: 150,
            grabCursor: true,
            centeredSlides: true,
            loop: true,
            slideToClickedSlide: true,
            navigation: {
                nextEl: swiperEl.querySelector('.swiper-button-next'),
                prevEl: swiperEl.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: swiperEl.querySelector('.swiper-pagination'),
                clickable: true,
            },
            breakpoints: {
                640: { slidesPerView: 2, spaceBetween: 16 },
                1024: { slidesPerView: 4.6 }
            },
            on: {
                init: function () {
                    // Play video on the active slide, pause all others
                    handleVideos(this);
                    // Repeat after a short delay to ensure correct state
                    setTimeout(() => handleVideos(this), 250);
                    // Set up sound toggle buttons
                    initSoundButtons(this);
                },
                slideChange: function () {
                    handleVideos(this);
                    updateSoundButtons(this);

                    //Initialize AB testing script
                    window._conv_q = window._conv_q || [];
                    _conv_q.push(['triggerConversion', '1004101849']);
                    console.log('Conversion triggered');
                },
                slideChangeTransitionEnd: function () {
                    handleVideos(this);
                    updateSoundButtons(this);
                }
            }
        });

        /**
         * Play video on the active slide, pause and mute all others.
         * Only the active slide can be unmuted.
         */
        function handleVideos(swiperInstance) {
            var slides = swiperInstance.slides;
            slides.forEach(function (slide, idx) {
                var video = slide.querySelector("video");
                var soundBtn = slide.querySelector('.ugc-slider__sound-btn');
                if (!video) return;
                if (idx === swiperInstance.activeIndex) {
                    try { video.play(); } catch (e) { /* Autoplay policy fallback */ }
                    if (soundBtn) soundBtn.disabled = false;
                } else {
                    video.pause();
                    video.currentTime = 0;
                    video.muted = true; // Always mute non-active slides
                    if (soundBtn) {
                        soundBtn.setAttribute('data-sound', 'off');
                        updateButtonIcons(soundBtn, true); // Show mute icon
                        soundBtn.disabled = true;
                    }
                }
            });
        }

        /**
         * Initialize all sound toggle buttons.
         * On page load, all videos are muted and all buttons set to 'off' (except for the active slide).
         */
        function initSoundButtons(swiperInstance) {
            swiperInstance.slides.forEach(function (slide, idx) {
                var video = slide.querySelector("video");
                var soundBtn = slide.querySelector('.ugc-slider__sound-btn');
                if (video && soundBtn) {
                    video.muted = true;
                    soundBtn.setAttribute('data-sound', 'off');
                    updateButtonIcons(soundBtn, true);
                    soundBtn.disabled = (idx !== swiperInstance.activeIndex);
                }
            });
        }

        /**
         * Enable the sound button only on the active slide,
         * disable it on all others.
         */
        function updateSoundButtons(swiperInstance) {
            swiperInstance.slides.forEach(function (slide, idx) {
                var soundBtn = slide.querySelector('.ugc-slider__sound-btn');
                if (!soundBtn) return;
                soundBtn.disabled = (idx !== swiperInstance.activeIndex);
            });
        }

        /**
         * Toggle mute/unmute state ONLY on the active slide.
         * Updates button state and icon.
         */
        swiperEl.addEventListener('click', function (e) {
            var btn = e.target.closest('.ugc-slider__sound-btn');
            if (!btn || btn.disabled) return;
            var slide = btn.closest('.ugc-carousel__slide');
            if (!slide) return;
            var video = slide.querySelector("video");
            if (!video) return;

            // Toggle mute
            video.muted = !video.muted;
            // Update button attribute and icon
            btn.setAttribute('data-sound', video.muted ? 'off' : 'on');
            updateButtonIcons(btn, video.muted);
        });

        /**
         * Helper: Update which icon is shown on the sound button.
         * Shows "volume-off" if muted, "volume-on" if not muted.
         */
        function updateButtonIcons(btn, isMuted) {
            var iconOn = btn.querySelector('.volume-on');
            var iconOff = btn.querySelector('.volume-off');
            if (isMuted) {
                if (iconOn) iconOn.style.display = 'none';
                if (iconOff) iconOff.style.display = 'block';
            } else {
                if (iconOn) iconOn.style.display = 'block';
                if (iconOff) iconOff.style.display = 'none';
            }
        }
    });
});
